import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Get } from "../config/api/get";
import { Post } from "../config/api/post";
import { CONTENT_TYPE, GALLERY } from "../config/constants";

const GALLERY_KEY = ["galleries"];

export const useGetAllGalleries = () => {
  const token = useSelector((state) => state.user.userToken);
  return useQuery({
    queryKey: GALLERY_KEY,
    queryFn: async ({ signal }) => {
      const { data } = await Get(GALLERY.getAllGalleries, token, { _: Date.now() }, { signal });
      return data?.galleries || [];
    },
    enabled: !!token,
  });
};

export const useAddGallery = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async (formData) => {
      const response = await Post(GALLERY.addGallery, formData, token, null, CONTENT_TYPE.FORM_DATA);
      if (response?.data?.status) return response.data;
      throw new Error(response?.data?.message || "Failed to add album");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: GALLERY_KEY }),
  });
};

export const useUpdateGallery = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async ({ id, data }) => {
      const response = await Post(
        GALLERY.updateGallery + id,
        data,
        token,
        null,
        CONTENT_TYPE.FORM_DATA
      );
      if (response?.data?.status) return response.data;
      throw new Error(response?.data?.message || "Failed to update album");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: GALLERY_KEY }),
  });
};

export const useDeleteGallery = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async (id) => {
      const response = await Get(GALLERY.deleteGallery + id, token);
      if (response?.status) return response;
      throw new Error(response?.message || "Failed to delete album");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: GALLERY_KEY }),
  });
};
